import { Injectable } from '@angular/core';

@Injectable()
export class AppSettingsService {

  public data: any;

  constructor() { }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/app-settings/app-settings.service.ts